import React, { useMemo } from "react";
import { GlobalDirectoryApprovalsSection } from "../../../../../global/directory";
import { GlobalButton, GlobalInlineSelect } from "../../../../../global/forms/GlobalFormFields";

/** Options for bulk status dropdown (includes Cancelled if missing from masters). */
export function buildMaintenanceBulkStatusSelectOptions(maintenanceStatuses) {
  const base = (maintenanceStatuses || []).map((s) => ({
    value: String(s.id),
    label: s.status_name,
  }));
  const hasCancelled = base.some((o) => String(o.label).toLowerCase() === "cancelled");
  if (!hasCancelled) base.push({ value: "4", label: "Cancelled" });
  return base;
}

/**
 * Strip between directory filters and grid — bulk status only (single row).
 */
export default function MaintenanceDirectoryStatusMarkingBar({
  selectedCount = 0,
  statusOptions,
  bulkNewStatusId,
  onBulkNewStatusIdChange,
  applyingBulkStatus,
  onMark,
  onClearSelection,
}) {
  const options = useMemo(() => statusOptions ?? [], [statusOptions]);

  const title =
    selectedCount > 0 ? `Status marking (${selectedCount} selected)` : "Status marking";

  return (
    <GlobalDirectoryApprovalsSection
      className="gds-approvals--maintenance-bulk-row"
      title={title}
      hint=""
      actions={
        <>
          <div className="gds-bulk-status-field">
            <GlobalInlineSelect
              value={bulkNewStatusId}
              onChange={onBulkNewStatusIdChange}
              placeholderOption="Select status…"
              options={options}
              ariaLabel="Select status to apply"
              disabled={applyingBulkStatus}
              className="gds-bulk-status-select"
            />
          </div>
          <GlobalButton
            variant="primary"
            size="sm"
            onClick={onMark}
            disabled={applyingBulkStatus || selectedCount === 0 || !bulkNewStatusId}
            loading={applyingBulkStatus}
          >
            Mark
          </GlobalButton>
          <GlobalButton
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            disabled={applyingBulkStatus || selectedCount === 0}
          >
            Clear selection
          </GlobalButton>
        </>
      }
    />
  );
}
